import { Plugin, Ref, inject, readonly, ref, warn } from "vue";
import { RecaptchaScriptLoadOptions, loadRecaptchaScript } from "./utils";

export type RecaptchaPluginOptions = RecaptchaScriptLoadOptions & {
  sitekey?: string;
};

export type RecaptchaPluginContext = Readonly<{
  isReady: Ref<boolean>;
  sitekey?: string;
}>;

export const RecaptchaPluginContextKey = "recaptcha-plugin";

// Whether we are did load the script.
let isInstalled = false;

// Global - only need to install the script once.
const isReady = ref(false);

/**
 * Plugin to install the g-recaptcha script.
 */
export const RecaptchaPlugin: Plugin<RecaptchaPluginOptions> = {
  install: (app, options) => {
    if (!isInstalled) {
      isInstalled = true;

      loadScript(options).catch((error) =>
        console.error("failed to load reCAPTCHA script.", error)
      );
    }

    app.provide(RecaptchaPluginContextKey, {
      isReady: readonly(isReady),
      sitekey: options.sitekey,
    });
  },
};

async function loadScript(options: RecaptchaPluginOptions) {
  console.debug("loading recaptcha script.");
  await loadRecaptchaScript(options);
  isReady.value = true;
  console.debug("Recaptcha script is ready.");
}

/**
 *
 * @returns
 */
export function useRecaptchaPlugin(): RecaptchaPluginContext {
  const context = inject<RecaptchaPluginContext>(RecaptchaPluginContextKey, {
    isReady: ref(false),
  });

  if (!context) {
    warn("The `recaptcha` plugin wasn't installed.");
    throw new Error(
      "`useRecaptchaContext` was called before plugin installation."
    );
  }

  return context;
}
